export default "/images/5eb9911cb73c9e7f741dccb3ab6875cd.avif";